import moment from 'moment';

const validDate = {
    isValidDate: function (dayValue, monthValue, yearValue) {
        monthValue = parseInt(monthValue, 10);
        const isValidDay = dayValue >= 1 && dayValue <= 31;
        const isValidMonth = monthValue >= 1 && monthValue <= 12;
        const isValidYear = yearValue >= 1000 && yearValue <= 9999;

        if (!isValidDay || !isValidMonth || !isValidYear) {
            return false;
        }

        if (monthValue === 2) {
            const isLeapYear = (yearValue % 4 === 0 && yearValue % 100 !== 0) || (yearValue % 400 === 0);
            const maxDays = isLeapYear ? 29 : 28;
            return dayValue <= maxDays;
        } else if ([4, 6, 9, 11].includes(monthValue)) {
            return dayValue <= 30;
        } else {
            return dayValue <= 31;
        }
    },

    validateDateInput: function (day, month, year, errorMessage) {
        const dateValue = day.value + month.value + year.value;

        if (dateValue.length === 0) {
            document.getElementById("error").innerHTML = `${errorMessage} is a required field.`;
            return false;
        }

        if (!this.isValidDate(day.value, month.value, year.value)) {
            document.getElementById("error").innerHTML = `Invalid ${errorMessage} Format, date should be MM/DD/YYYY`;
            return false;
        }

        return true;
    }
};

const formatNumnberWithComma = (number) => {
    // debugger;    
    // Check if number is defined before calling toString()
    if (number !== undefined && number !== null) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
};


const formatAmountWithComma = (amount) => {
    // Check if amount is undefined or null
    if (amount === undefined || amount === null || amount === 0) {
        return "0.00"; // or any other default value you prefer
    }
    // For non-zero amounts, format with commas and two decimal places
    return amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const formatInputDate = (date) => {
    // Check if the date is valid
    if (moment(date).isValid()) {
        // Format the date in the desired format, keeping it in the local time zone
        return moment(date).startOf('day').format('YYYY-MM-DDTHH:mm:ss[Z]');
    } else {
        // Handle the case where the date is not valid (optional)
        return null;
    }
};

const toLocalDate = (utcDateString) => {
    debugger;
    if (utcDateString !== null && utcDateString !== undefined) {
        const utcDate = new Date(utcDateString);
        const localDate = new Date(utcDate.getTime() + utcDate.getTimezoneOffset() * 60000);
        console.log(localDate);
        return localDate;
    } else {
        return null;
    }
};

function formatDate(date) {
    debugger;
    let modifiedDate = new Date(date);

    const month = String(modifiedDate.getMonth() + 1).padStart(2, '0');
    const day = String(modifiedDate.getDate()).padStart(2, '0');
    const year = String(modifiedDate.getFullYear());
    return `${month}/${day}/${year}`;
}

// Helper function to filter out non-numeric characters and allow up to a specified number of digits
const getValidNumericValue = (value, length) => {
    let filteredValue = value.replace(/\D/g, '');

    if (length) {
        filteredValue = filteredValue.substring(0, length);
    }

    return filteredValue;
};

// Helper function to filter out non-numeric characters and allow up to a specified number of digits
const getValidDecimalValue = (value, length) => {
    let filteredValue = value.replace(/[^\d.]/g, '');

    if (length) {
        filteredValue = filteredValue.substring(0, length);
    }

    return filteredValue;
};

const removeCommafromNumber = (number) => {
    // debugger;    
    // Check if number is defined before calling toString()
    if (number !== undefined && number !== null) {
        return number.toString().replace(/,/g, "");
    }
};

export {
    validDate,
    formatNumnberWithComma,
    formatAmountWithComma,
    formatDate,
    formatInputDate,
    toLocalDate,
    getValidNumericValue,
    removeCommafromNumber,
    getValidDecimalValue
};